import { render, staticRenderFns } from "./DeudorDetalle.vue?vue&type=template&id=5ab21a3a"
import script from "./DeudorDetalle.vue?vue&type=script&lang=js"
export * from "./DeudorDetalle.vue?vue&type=script&lang=js"
import style0 from "./DeudorDetalle.vue?vue&type=style&index=0&id=5ab21a3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports